import { h, Component } from 'preact';
import dlv from 'dlv';

import { configure } from '../../../config';

import { Desktop } from './device/desktop.js';
import { Tablet } from './device/tablet.js';
import { Phone } from './device/phone.js';

import { initializeTaboolaJs, finalizeTaboolaJs } from '../../pieces/taboola-js';
import { COMMON_CONFIGS, setTheme } from '../../../lib/page';
import { shuffle } from '../../../lib/utils';
import { fetchFromDailyMotionRelatedVideos } from '../../../lib/dailymotion';
import { fetchVideoData } from '../../../lib/data';
import { initNewsroom } from '../../../lib/newsroom';
import { getPageConfig, getDeviceTemplate } from '../../../lib/device';
import { trackPageLoad } from '../../../lib/tracking';

import { trackingProvider, DIMENSION } from '@cube/track';
import { deviceVariance } from '@cube/blocks';


@trackingProvider({
	[DIMENSION.componentpath]: 'ReadVideoPage'
})
@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.readVideo',
	browseCategories: 'singleCube.browseCategories',
	clientDisplayName: 'clientDisplayName'
})
@deviceVariance()
export default class ReadVideo extends Component {

	componentWillMount() {
		let device = this.props.device,
			pageConfig = getPageConfig(this.props.pageConfig, device),
			Device = getDeviceTemplate({ device, Desktop, Tablet, Phone });
		this.setState({ pageConfig, Device });

		setTheme(pageConfig);
		initializeTaboolaJs({ video: 'auto' });
		initNewsroom({ taboolaConfig: this.props.taboolaConfig });

		this.setState({
			shuffledCategories: shuffle(dlv(this.props, 'pageConfig.clusters.randomDailyMotion.categories'))
		});

		let player = this.props.player && this.props.player.toLowerCase();
		if (player === 'sf' || player === 'youtube') {
			return fetchVideoData({ imageSizes: 'w=640,h=360|w=300,h=169', ...this.props })
				.then( res => {
					this.setState({
						asset: res,
						relatedVideos: res.playlist && res.playlist.length > 0 ? res.playlist : false,
						playlistMode: (player === 'youtube' ? 'below' : 'side')
					});
				});
		}
		else if (player === 'dailymotion') {
			return fetchFromDailyMotionRelatedVideos(this.props)
				.then( res => {
					if (res.articles && res.articles.length > 0) {
						this.setState({
							relatedVideos: res.articles,
							playlistMode: 'side'
						});
					}
				});
		}
	}

	componentDidMount() {
		finalizeTaboolaJs();
		trackPageLoad(this.context);
	}

	render({ device, player, ...props }, { Device, pageConfig, asset, relatedVideos, shuffledCategories, playlistMode }) {
		if (player) player = player.toLowerCase();

		return (
			<Device
				asset={asset}
				relatedVideos={relatedVideos}
				player={player}
				shuffledCategories={shuffledCategories}
				playlistMode={playlistMode}
				{...props}
				pageConfig={pageConfig}
			/>
		);
	}
}
